// const { ApplicationService } = require("./_services/api/application/application.service");
const { TokenStorage, CommonStorage } = require("./_services/storage");

import { ApplicationService } from "./_services/api/application/application.service";
import { store } from "./_store";

// Create a new BroadcastChannel object
const broadcastChannel = new BroadcastChannel('session-channel');

broadcastChannel.onmessage = (event) => {
    const loggedIn = !!TokenStorage.getToken();
    if (event.data && event.data.action === 'app_version' && loggedIn) {

        // Get API Version
        ApplicationService.getAPIVersion().then((res) => {
            if (res.data) {
                const APIV = CommonStorage.getItems('CUSTOMER_PREFIX_API_VERSION');
                if (!APIV) {
                    CommonStorage.saveItems('CUSTOMER_PREFIX_API_VERSION', res.data);
                    store.dispatch("ui/apiVersionUpdate", false);
                } else {
                    if (APIV == res.data) {
                        store.dispatch("ui/apiVersionUpdate", false);
                    } else {
                        store.dispatch("ui/apiVersionUpdate", true);
                    }
                }
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log('API Version Request Failed ', err);
        });

        ApplicationService.getUIVersion(window.location.origin).then((res) => {
            if (res && res.data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(res.data, 'text/html');

                // Find the meta tag with the name 'version'
                const versionMetaTag = doc.querySelector('meta[name="version"]');

                // Check if the meta tag is found
                if (versionMetaTag) {
                    // Get the content attribute of the meta tag
                    const version = versionMetaTag.getAttribute('content');
                    const UiV = CommonStorage.getItems('CUSTOMER_PREFIX_UI_VERSION');

                    if (!UiV) {
                        CommonStorage.saveItems('CUSTOMER_PREFIX_UI_VERSION', version);
                        store.dispatch("ui/uiVersionUpdate", false);
                    } else {
                        if (version == UiV) {
                            store.dispatch("ui/uiVersionUpdate", false);
                        } else {
                            store.dispatch("ui/uiVersionUpdate", true);
                        }
                    }
                }
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.log("CX Version Request Failed ", err);
        });

    }
};